export { FunnelsPage } from "./ui/funnels-page"
